var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"avatar rounded-circle",class:{
    disabled: _vm.disabled,
    'avatar-placeholder': _vm.isPlaceholder,
    'avatar-status': _vm.status,
    'active': _vm.active,
  },style:({width: (_vm.size + "px"), height: (_vm.size + "px")})},[(!_vm.isPlaceholder)?_c('img',{attrs:{"src":_vm.source,"alt":_vm.user.name,"width":_vm.size,"height":_vm.size}}):(!!_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_c('SvgIcon',{attrs:{"name":"components/user","width":("" + (_vm.size * 0.40625)),"height":("" + (_vm.size * 0.5))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }